import React, {Component} from 'react'
import Select from 'react-select'
import {Button} from 'react-bootstrap'

class SelectGroup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
    }
  }

  toggleOpen = () => {
    this.setState(state => ({isOpen: !state.isOpen}))
  }

  handleStateChange = event => {
    this.toggleOpen()
    this.props.handleChange(event)
  }

  render() {
    const selectStyles = {
      control: provided => ({...provided, minWidth: 240, margin: 8}),
      menu: () => ({boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)'}),
    }
    const Menu = props => {
      const shadow = 'hsla(218, 50%, 10%, 0.1)'
      return (
        <div
          css={{
            backgroundColor: 'red',
            borderRadius: 4,
            boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
            marginTop: 8,
            position: 'absolute',
            zIndex: 2,
          }}
          {...props}
        />
      )
    }
    const Blanket = props => (
      <div
        css={{
          bottom: 0,
          left: 0,
          top: 0,
          right: 0,
          position: 'fixed',
          zIndex: 1,
        }}
        {...props}
      />
    )
    const Dropdown = ({children, isOpen, target, onClose}) => (
      <div css={{position: 'relative'}}>
        {target}
        {isOpen ? <Menu>{children}</Menu> : null}
        {isOpen ? <Blanket onClick={onClose} /> : null}
      </div>
    )
    const Svg = p => (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        focusable="false"
        role="presentation"
        {...p}
      />
    )
    const DropdownIndicator = () => <div css={{height: 24, width: 32}}></div>
    const ChevronDown = () => (
      <Svg style={{marginRight: -6}}>
        <path
          d="M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </Svg>
    )
    return (
      <div
        className={
          this.props.disabled
            ? 'display_field not-allowed'
            : this.state.isOpen
            ? 'display_field box-shadow'
            : 'display_field'
        }
      >
        <Dropdown
          isOpen={this.state.isOpen}
          onClose={this.toggleOpen}
          target={
            <Button
              className={this.state.isOpen ? 'display_text display_ismenuopen' : 'display_text'}
              iconAfter={<ChevronDown />}
              onClick={this.toggleOpen}
              isSelected={true}
            >
              {this.props.id ? `${this.props.name}` : this.props.placeholder}
              <svg
                height="20"
                width="20"
                viewBox="0 0 20 20"
                aria-hidden="true"
                focusable="false"
                className="css-6q0nyr-Svg"
              >
                <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
              </svg>
            </Button>
          }
        >
          <Select
            className="basic-single display_select"
            backspaceRemovesValue={false}
            components={{DropdownIndicator, IndicatorSeparator: null}}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            onChange={this.handleStateChange}
            options={this.props.optionItems}
            placeholder="Search"
            menuIsOpen
            styles={selectStyles}
            tabSelectsValue={false}
            value={this.props.optionItems.filter(({value}) => value === this.props.id)}
          />
        </Dropdown>
      </div>
    )
  }
}

export default SelectGroup
